<!--
  Shared building blocks, stamped into either the desktop or mobile layout via
  ngTemplateOutlet. Kept as templates (rather than duplicated markup) so the
  user-settings popover keeps a single `#opUserSettings` for the @ViewChild.
-->
<ng-template #logo>
  <img class="alv-logo" src="assets/logos/alveri-logo.svg" alt="alveri-logo" />
</ng-template>

<ng-template #userSettings>
  <p-button
    #btn
    (click)="toggleUserSettings($event)"
    label="{{ userInitials() }}"
    class="user-avatar"
    severity="info"
  />
  <p-popover
    #opUserSettings
    [appendTo]="btn"
    (onShow)="onUserSettingsPopoverShow()"
    styleClass="user-settings-popover"
  >
    <div class="flex flex-column gap-4">
      <div>
        <ul class="p-0 m-0 flex flex-column">
          <li
            *ngFor="let member of userSettingsOptions"
            class="flex items-center gap-2 px-2 py-3 hover:bg-emphasis cursor-pointer rounded-border"
          >
            <div
              (click)="member.action?.()"
              (keydown.enter)="member.action?.()"
              (keydown.space)="member.action?.()"
              tabindex="0"
              role="button"
            >
              <i [ngClass]="member.icon" *ngIf="member.icon"></i>
              <span class="font-medium">{{ member.text }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </p-popover>
</ng-template>

<ng-template #operatorSelect>
  @if (!hideMenuAndOperatorSelection()) {
    <div class="operators-select">
      <div class="input-icon-left">
        <i class="fa fa-group icon"></i>
        <p-select
          [options]="operatorsOptions()"
          optionLabel="name"
          (onChange)="onOperatorChange($event)"
          placeholder="Betreiber auswählen"
          class="w-full md:w-56"
          [formControl]="operatorFormControl"
        />
      </div>
    </div>
  }
</ng-template>

<ng-template #menuNav>
  @if (!hideMenuAndOperatorSelection()) {
    <div class="menubar-wrapper justify-content-start">
      <p-menubar [model]="menuItems()"></p-menubar>
      <p-breadcrumb
        class="max-w-full"
        [model]="styledBreadcrumbs()"
        [home]="home"
      />
    </div>
  }
</ng-template>

@if (viewport.isMobile()) {
  <!-- Mobile: stacked — logo / (settings + operator) / menu + breadcrumbs -->
  <div class="header-wrapper header-wrapper--mobile flex flex-column gap-2 p-2">
    <div class="flex justify-content-center">
      <ng-container [ngTemplateOutlet]="logo" />
    </div>

    <div class="flex flex-row align-items-center justify-content-between gap-2">
      <ng-container [ngTemplateOutlet]="userSettings" />
      <ng-container [ngTemplateOutlet]="operatorSelect" />
    </div>

    <ng-container [ngTemplateOutlet]="menuNav" />
  </div>
} @else {
  <!-- Desktop: single row — logo | menu + breadcrumbs | operator + settings -->
  <div class="header-wrapper">
    <div class="flex flex-row justify-content-between">
      <div class="flex">
        <ng-container [ngTemplateOutlet]="logo" />
      </div>

      <div class="flex gap-4 justify-content-center">
        <div class="flex flex-row justify-content-center p-2">
          <ng-container [ngTemplateOutlet]="menuNav" />
        </div>
      </div>

      <div class="gap-2 filter-bar p-2">
        <div class="flex flex-row-reverse">
          <div class="">
            <ng-container [ngTemplateOutlet]="userSettings" />
          </div>
          <ng-container [ngTemplateOutlet]="operatorSelect" />
        </div>
      </div>
    </div>
  </div>
}
